import styled from "styled-components";

export const LayoutContainer = styled.div`
  padding-left: 73px;
  padding-top: 64px;
`;